module.exports = __webpack_public_path__ + "img/folder-open-fill.abe63c21.svg";